import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Dialog, TextField } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ImageCropperDialog } from 'components/common/ImageCropperDialog';
import { ImageDropzoneOrPreview } from 'components/common/ImageDropzoneOrPreview';
import { GradientButton } from 'components/common/material-ui/custom-components';
import Style from './ImageDialog.style';
var defaultImage = {
  legend: '',
  credits: ''
};

var ImageDialog = function ImageDialog(_ref) {
  var _imageData$_originalI;

  var open = _ref.open,
      initialData = _ref.initialData,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      imageRatio = _ref.imageRatio,
      _ref$displayAnchor = _ref.displayAnchor,
      displayAnchor = _ref$displayAnchor === void 0 ? false : _ref$displayAnchor,
      imageConstraints = _ref.imageConstraints;

  var _useState = useState(false),
      uploadError = _useState[0],
      setUploadError = _useState[1];

  var _useState2 = useState(initialData !== null && initialData !== void 0 ? initialData : defaultImage),
      imageData = _useState2[0],
      setImageData = _useState2[1];

  var _useState3 = useState(false),
      isCropperOpen = _useState3[0],
      setIsCropperOpen = _useState3[1];

  var intl = useIntl();
  var handleConfirm = useCallback(function () {
    if (imageData !== undefined) {
      onConfirm(imageData);
    }
  }, [onConfirm, imageData]);

  var handleClose = function handleClose() {
    onClose(); // reset all imageData when closing the modal

    if (isEmpty(imageData.imgUrl)) {
      setImageData(initialData !== null && initialData !== void 0 ? initialData : defaultImage);
    }
  };

  var handleImageDropped = function handleImageDropped(url) {
    setUploadError(url === undefined);

    if (url !== undefined) {
      setImageData(function (currentState) {
        return {
          legend: currentState.legend,
          credits: currentState.credits,
          imgUrl: url
        };
      });
      setIsCropperOpen(true);
    }
  };

  var handleCloseCrop = function handleCloseCrop() {
    return setIsCropperOpen(false);
  };

  var handleConfirmCrop = function handleConfirmCrop(url, originUrl, crop, anchor) {
    setImageData(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        imgUrl: url,
        _originalImage: {
          imgUrl: originUrl,
          cropArea: crop
        },
        imageAnchor: anchor
      });
    });
    setIsCropperOpen(false);
  };

  useEffect(function () {
    setImageData(initialData !== null && initialData !== void 0 ? initialData : defaultImage);
  }, [initialData]);

  var resetImgUrl = function resetImgUrl() {
    return setImageData(function (currentState) {
      return {
        legend: currentState.legend,
        credits: currentState.credits,
        imgUrl: ''
      };
    });
  };

  return __jsx(Dialog, {
    open: open,
    onClose: handleClose,
    disableRestoreFocus: true,
    "data-testid": "image-dialog"
  }, __jsx(Style.CloseButton, {
    onClick: handleClose,
    "data-testid": "close-image-dialog-button"
  }), __jsx(FormattedMessage, {
    id: "image-modal.title",
    tagName: Style.Title
  }), __jsx(ImageDropzoneOrPreview, {
    imgSrc: imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl,
    onImageDropped: handleImageDropped,
    onImageDeleted: resetImgUrl,
    onCropButtonClick: function onCropButtonClick() {
      return setIsCropperOpen(true);
    },
    imageConstraints: imageConstraints,
    imageRatio: imageRatio
  }), __jsx(Style.InputContainer, null, __jsx(TextField, {
    id: "image-modal-legend",
    value: imageData === null || imageData === void 0 ? void 0 : imageData.legend,
    fullWidth: true,
    type: "text",
    onChange: function onChange(event) {
      return setImageData(function (currentState) {
        return _objectSpread(_objectSpread({}, currentState), {}, {
          legend: event.target.value
        });
      });
    },
    label: intl.formatMessage({
      id: 'image-modal.legend'
    }),
    variant: "outlined"
  })), __jsx(Style.InputContainer, null, __jsx(TextField, {
    id: "image-modal-credits",
    value: imageData === null || imageData === void 0 ? void 0 : imageData.credits,
    fullWidth: true,
    type: "text",
    onChange: function onChange(event) {
      return setImageData(function (currentState) {
        return _objectSpread(_objectSpread({}, currentState), {}, {
          credits: event.target.value
        });
      });
    },
    label: intl.formatMessage({
      id: 'image-modal.credits'
    }),
    variant: "outlined"
  })), __jsx(Style.ButtonContainer, null, __jsx(GradientButton, {
    disabled: (imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl) === undefined || uploadError,
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "image-modal.confirm"
  }))), (imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl) != null && __jsx(ImageCropperDialog, {
    imgUrl: imageData._originalImage ? imageData._originalImage.imgUrl : imageData.imgUrl,
    open: isCropperOpen,
    imageRatio: imageRatio,
    onClose: handleCloseCrop,
    onConfirm: handleConfirmCrop,
    originalCrop: (_imageData$_originalI = imageData._originalImage) === null || _imageData$_originalI === void 0 ? void 0 : _imageData$_originalI.cropArea,
    originalImageAnchor: imageData.imageAnchor,
    displayAnchor: displayAnchor,
    constraints: imageConstraints === null || imageConstraints === void 0 ? void 0 : imageConstraints.constraints
  }));
};

export default ImageDialog;